/* ****************************************************************************************************

  slider(slick)

**************************************************************************************************** */
jQuery(function($) {

  /* ======================================================================

    数字ゼロパディング関数

  ====================================================================== */
  function zeroPadding(num,length) {
    return ('0000000000' + num).slice(-length);
  }

  /* ======================================================================

    トップのスタッフメッセーじ

  ====================================================================== */
  if ($('#js-staff-message').length) {

    /* 変数
    ---------------------------------------------------------------------- */
    var $staffSlide = $('#js-staff-message');
    var $staffSlideCont = $staffSlide.children('.s-staff-message__inner');

    /* スライド初期化時にクラスを追加
    ---------------------------------------------------------------------- */
    // はじめはdisplay:noneしておき、.is-activeが追加されたらdisplay:block
    $staffSlideCont.on('init', function() {
      $staffSlide.addClass('is-active');
    });
    $staffSlideCont.slick({
      mobileFirst: true,
      // fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: false,
      adaptiveHeight: false,
      arrows: true,
      appendArrows: $staffSlideCont,
      focusOnSelect: false,
      prevArrow: '<div class="s-staff-message__arrow s-staff-message__arrow--prev">PREV</div>',
      nextArrow: '<div class="s-staff-message__arrow s-staff-message__arrow--next">NEXT</div>',
      dots: true,
      dotsClass: 's-staff-message__nav',
      customPaging: function(slick, index){
        return '<div class="s-staff-message__dot"></div>';
      },
      autoplay: false,
      autoplaySpeed: 4000,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      cssEase: 'ease-in-out',
      // responsive: [
      //   {
      //     breakpoint: 767,
      //     settings: {
      //       slidesToShow: 4,
      //       centerPadding: '3rem',
      //     }
      //   }
      // ]
    });
    $staffSlideCont.on('touchmove', function(event, slick, currentSlide, nextSlide){
      $staffSlideCont.slick('slickPlay');
    });
  }// if ($('#js-staff-message').length)

  /* ======================================================================

    トップの企業理念

  ====================================================================== */
  if ($('#js-philosophy').length) {

    /* 変数
    ---------------------------------------------------------------------- */
    var $philSlide = $('#js-philosophy');
    var $philSlideCont = $philSlide.children('.s-philosophy__list');

    /* スライド初期化時にクラスを追加
    ---------------------------------------------------------------------- */
    // はじめはdisplay:noneしておき、.is-activeが追加されたらdisplay:block
    $philSlideCont.on('init', function() {
      $philSlide.addClass('is-active');
      var _maxHeight = 0;
      $('.s-philosophy__divider').each(function() {
        if ($(this).height() > _maxHeight) {
          _maxHeight = $(this).height();
        }
      });
       $('.s-philosophy__divider').height(_maxHeight);
    });
    $philSlideCont.slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: false,
      adaptiveHeight: false,
      arrows: true,
      appendArrows: $philSlide,
      focusOnSelect: false,
      prevArrow: '<div class="s-philosophy__arrow s-philosophy__arrow--prev">PREV</div>',
      nextArrow: '<div class="s-philosophy__arrow s-philosophy__arrow--next">NEXT</div>',
      dots: true,
      dotsClass: 's-philosophy__nav',
      customPaging: function(slick, index){
        return '<div class="s-philosophy__dot"></div>';
      },
      autoplay: true,
      autoplaySpeed: 5500,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      cssEase: 'ease-in-out',
      // responsive: [
      //   {
      //     breakpoint: 767,
      //     settings: {
      //       slidesToShow: 4,
      //       centerPadding: '3rem',
      //     }
      //   }
      // ]
    });
    $philSlideCont.on('touchmove', function(event, slick, currentSlide, nextSlide){
      $philSlideCont.slick('slickPlay');
    });
  }// if ($('#js-home-slide').length)

  /* ======================================================================

    事業部の紹介

  ====================================================================== */
  if ($('#js-home-business-list').length) {

    /* 変数
    ---------------------------------------------------------------------- */
    var $businessSlide = $('#js-home-business-list');
    var $businessSlideCont = $businessSlide.children('.s-home-business-list__inner');

    /* スライド初期化時にクラスを追加
    ---------------------------------------------------------------------- */
    // はじめはdisplay:noneしておき、.is-activeが追加されたらdisplay:block
    $businessSlideCont.on('init', function() {
      $businessSlide.addClass('is-active');
      $businessSlide.append('<div class="s-home-business-list-counter"><p class="s-home-business-list-counter__current"></p> / <p class="s-home-business-list-counter__total"></p></div>');
      var _mql = window.matchMedia('screen and (max-width: 767px)');
      var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
      // ▼サイズ揃える
      _mql.addListener(adjustBusinessSlide);
      // ▼初回ロード時
      adjustBusinessSlide(_mql);
       // ▼サイズ揃える関数
       function adjustBusinessSlide(_mql) {
         if (_mql.matches) {
           var _maxHeight = 0;
           $('.s-home-business-list__divider').each(function() {
             if ($(this).height() > _maxHeight) {
               _maxHeight = $(this).height();
             }
           });
            $('.s-home-business-list__divider').height(_maxHeight);
           // console.log('spサイズだお');
         } else {
           // console.log('pcサイズだお');
         }
       }
    });
    $businessSlideCont.slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: true,
      focusOnSelect: true,
      arrows: true,
      appendArrows: $businessSlide,
      prevArrow: '<div class="s-home-business-list__arrow s-home-business-list__arrow--prev"><p>PREV</p></div>',
      nextArrow: '<div class="s-home-business-list__arrow s-home-business-list__arrow--next"><p>NEXT</p></div>',
      dots: false,
      // dotsClass: 's-company-slide__nav',
      // customPaging: function(slick, index){
      //   return '<div class="s-company-slide__dot"></div>';
      // },
      autoplay: false,
      // autoplaySpeed: 5000,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerPadding: '0',
            variableWidth: false,
            centerMode: false,
            dots: true,
            appendDots: $('#js-home-business'),
            dotsClass: 's-home-business-nav',
            customPaging: function(slick, i){
              var _category = slick.$slides.eq(i).data('business');
              var _content = slick.$slides.eq(i).find('.s-home-business-list__title').html();
              var _num = slick.$slides.eq(i).find('.s-home-business-list__label').first().text();
              return '<div class="s-home-business-nav__item s-home-business-nav__item--type_' + _category + '"><div class="s-home-business-nav__inner">' +
                '<p class="s-home-business-nav__title">' + _num + '</p>' +
                '<p class="s-home-business-nav__txt">' + _content + '</p>' +
                '</div></div>';
            },
            // dotsClass: 's-philosophy__nav',
            // customPaging: function(slick, index){
            //   return '<div class="s-philosophy__dot"></div>';
            // },
          }
        }
      ]
    });
    $businessSlideCont.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      nextSlide = nextSlide + 1;
      nextSlide = zeroPadding(nextSlide, 2);
      $('.s-home-business-list-counter__current').text(nextSlide);
    });
    var _currentSlide = $businessSlideCont.slick('slickCurrentSlide');
    _currentSlide = _currentSlide + 1;
    _currentSlide = zeroPadding(_currentSlide, 2);
    var _totalSlide = '11';
    $('.s-home-business-list-counter__current').text(_currentSlide);
    $('.s-home-business-list-counter__total').text(_totalSlide);
    // ▼ナビゲーション表示
     // $('.s-home-business-nav').prepend('<li class="s-home-business-nav__guide"><div><p class="s-home-business-nav__title">CHOICE<br>BUSINESS</p><p class="s-home-business-nav__txt">事業部をクリックすると<br>切り替わります</p></div></li>');
  }// if ($('#js-bnr-slide').length)

  /* ======================================================================

    事業部紹介募集職種

  ====================================================================== */
  if ($('.js-job-gallery').length) {

    /* 変数
    ---------------------------------------------------------------------- */
    var $jobGallery = $('.js-job-gallery');

    /* hoge
    ---------------------------------------------------------------------- */
    (function() {
      var _mql = window.matchMedia('screen and (max-width: 767px)');
      var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
      var _slickFlag = false;
      // ▼ブレイクポイントの瞬間に発火
      _mql.addListener(adjustGallery);
      // ▼初回ロード時
      adjustGallery(_mql);
      // ▼サイズ揃える関数
      function adjustGallery(_mql) {
        if (_mql.matches) {
          $jobGallery.each(function(index) {
            var $jobGalleryCont = $jobGallery.eq(index).find('.s-job-gallery__list');
            $jobGalleryCont.slick({
              mobileFirst: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '0',
              variableWidth: true,
              focusOnSelect: true,
              arrows: false,
              dots: true,
              appendDots: $jobGallery.eq(index),
              dotsClass: 's-job-gallery__nav',
              customPaging: function(slick, index){
                return '<div class="s-job-gallery__dot"></div>';
              },
              autoplay: false,
              // autoplaySpeed: 5000,
              infinite: true,
              cssEase: 'ease-in-out',
            });
          });
          _slickFlag = true;
        } else {
          if (_slickFlag) {
            $jobGallery.find('.s-job-gallery__list').slick('unslick');
            _slickFlag = false;
          }
        }
      }
    })();
  }// if ($('.js-job-gallery').length) {

  /* ======================================================================

    福利厚生

  ====================================================================== */
  if ($('.js-gallery').length) {

    /* 変数
    ---------------------------------------------------------------------- */
    var $gallery = $('.js-gallery');
    var $galleryCont = $gallery.children('.p-gallery__inner');

    /* hoge
    ---------------------------------------------------------------------- */
    (function() {
      var _mql = window.matchMedia('screen and (max-width: 767px)');
      var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
      var _slickFlag = false;
      // ▼ブレイクポイントの瞬間に発火
      _mql.addListener(adjustWelfare);
      // ▼初回ロード時
      adjustWelfare(_mql);
      // ▼関数
      function adjustWelfare(_mql) {
        if (_mql.matches) {
          $galleryCont.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            variableWidth: false,
            focusOnSelect: true,
            arrows: false,
            // appendArrows: $businessMember,
            // prevArrow: '<div class="s-business-member__arrow s-business-member__arrow--prev"></div>',
            // nextArrow: '<div class="s-business-member__arrow s-business-member__arrow--next"></div>',
            dots: true,
            dotsClass: 'p-gallery__nav',
            customPaging: function(slick, index){
              return '<div class="p-gallery__dot"></div>';
            },
            autoplay: true,
            autoplaySpeed: 4000,
            infinite: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: true,
            swipeToSlide: true,
            touchMove: true,
            cssEase: 'ease-in-out',
          });
          _slickFlag = true;
        } else {
          if (_slickFlag) {
             $galleryCont.slick('unslick');
            _slickFlag = false;
          }
        }
      }
    })();

  }// if ($('#js-on-off').length) {

  /* ======================================================================

    事業詳細メンバー

  ====================================================================== */
  if ($('#js-business-member').length) {

    /* 変数
    ---------------------------------------------------------------------- */
    var $businessMember = $('#js-business-member');
    var $businessMemberCont = $businessMember.children('.s-business-member__container');
    var _$businessMemberLength = $businessMemberCont.find('.s-business-member__item').length;

    /* スライダー化の前に番号を追加する
    ---------------------------------------------------------------------- */
    var $businessMemberCard = $businessMember.find('.p-card');
    var $businessMemberOrder = 0;
    $businessMemberCard.each(function() {
      $businessMemberOrder++;
      $businessMemberOrder = zeroPadding($businessMemberOrder, 2);
      var $cardBody = $(this).find('.p-card__body');
      $cardBody.append('<p class="p-card__order">' + $businessMemberOrder + '</p>');
    });

    /* hoge
    ---------------------------------------------------------------------- */
    (function() {
      var _mql = window.matchMedia('screen and (max-width: 767px)');
      var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
      var _slickFlag = false;
      // ▼ブレイクポイントの瞬間に発火
      _mql.addListener(adjustMember);
      // ▼初回ロード時
      adjustMember(_mql);
      // ▼関数
      function adjustMember(_mql) {
        if (_mql.matches) {
          $businessMemberCont.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            variableWidth: false,
            focusOnSelect: true,
            arrows: true,
            appendArrows: $businessMember,
            prevArrow: '<div class="s-business-member__arrow s-business-member__arrow--prev"></div>',
            nextArrow: '<div class="s-business-member__arrow s-business-member__arrow--next"></div>',
            dots: false,
            autoplay: false,
            // autoplaySpeed: 5000,
            infinite: true,
            cssEase: 'ease-in-out',
          });
          $businessMember.append('<div class="s-business-member__counter"><p class="s-business-member__current"></p> / <p class="s-business-member__total"></p></div>');
          $businessMemberCont.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            nextSlide = nextSlide + 1;
            nextSlide = zeroPadding(nextSlide, 2);
            $('.s-business-member__current').text(nextSlide);
          });
          var _currentSlide = $businessMemberCont.slick('slickCurrentSlide');
          _currentSlide = _currentSlide + 1;
          _currentSlide = zeroPadding(_currentSlide, 2);
          var _totalSlide = _$businessMemberLength;
          _totalSlide = zeroPadding(_totalSlide, 2);
          $('.s-business-member__current').text(_currentSlide);
          $('.s-business-member__total').text(_totalSlide);
          _slickFlag = true;
        } else {
          if (_slickFlag) {
             $businessMemberCont.slick('unslick');
            _slickFlag = false;
          }
        }
      }
    })();
  }// if ($('.js-job-gallery').length) {
});
